import { render, staticRenderFns } from "./LoggedInLayout.vue?vue&type=template&id=0e5a230b&scoped=true&"
import script from "./LoggedInLayout.vue?vue&type=script&lang=js&"
export * from "./LoggedInLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a230b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
